import { createUserManager } from "redux-oidc";

const clientId = "57d78c7b-0c9f-416e-8c5a-0ac66f04cf48"; //GUID Client Application ID
const tenantId = "6aa88db0-b38c-43a9-83a7-18c2294002e5"; //GUID Azure Tenant ID
const resourceId = "api://5ba09613-bfc9-4988-93b4-90999978e29d"; //GUID API Application ID

const userManagerConfig = {
    authority: `https://login.microsoftonline.com/${tenantId}/.well-known/openid-configuration`,
    client_id: clientId,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`,
    automaticSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: false,
    scope: "openid profile",
    response_type: "token id_token",
    //response_type: "code",
    extraQueryParams: {
        resource: resourceId
    },
    signingKeys: [
    ]
};

const userManager = createUserManager(userManagerConfig);

export default userManager;